/* Scroll reveal for .reveal, ported from the mockup.

   The contract with hk-pages.css is deliberate: the stylesheet leaves .reveal
   visible by default and only arms the animation for html.hk-reveal. This file is
   the only thing that sets that class, and it sets it after confirming the browser
   has IntersectionObserver. If this script never runs, never loads, or throws, the
   content stays on screen. Hiding content is opt in, and only this file can opt in.

   That ordering matters more than the animation: before this existed, .reveal was
   opacity:0 with nothing to undo it, which left the promise panel on /pages/about
   rendering as an empty white box. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var items = document.querySelectorAll('.rte .reveal');
  if (!items.length) return;

  document.documentElement.classList.add('hk-reveal');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  items.forEach(function (el) {
    /* Anything already in view on load is shown immediately rather than animated,
       so the top of the page never flashes empty. */
    var top = el.getBoundingClientRect().top;
    if (top < window.innerHeight) el.classList.add('in');
    else io.observe(el);
  });
})();
